(function () {
    'use strict';

    angular
        .module('app.eventDisplay')
        .controller('EventDisplayListController', EventDisplayListController);

    EventDisplayListController.$inject = ['$state','common', 'dataservice', 'config'];
    /* @ngInject */
    function EventDisplayListController($state, common, dataservice, config) {
        var vm = this;

        vm.title = 'Event Display List';
        vm.displayedItems = [];
        vm.items = [];
        vm.refresh = refresh;
        vm.licenseInfo = {};
        vm.isLicenseValid = false;
        vm.isLoading = true;
        vm.copy = copy;
        vm.isAdmin = common.userService.userType() === "2";
        activate();

        function activate() {
            var promises = [ getItems(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                vm.isLicenseValid = vm.licenseInfo.NumberOfDisplaysLicensed >= vm.licenseInfo.NumberOfDisplaysInUse;
                return vm.licenseInfo;
            }, function (error) { });
        }


        function getItems() {
            return dataservice.getItems('api/EventDisplay').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function refresh() {
            getItems();
        }

        function copy(id) {
            var dto = {
                data: id
            };
            return dataservice.saveItem('api/EventDisplay/Copy', dto).then(function (response) {
                var newId = response.data.Message;
                $state.transitionTo('eventdisplay.details', {id: newId})
                
                
            }, function (error) { });
        }
    }
})();
